import { Link, useNavigate } from "react-router-dom";
import menu from "../resources/menu.svg";
import logo from "../resources/logo-white.svg";
import React, { useState } from 'react';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import {  useLocation } from "react-router-dom";
  

function Header() {
    let navigate = useNavigate();
    let location = useLocation(); 

    return (
        <div>
            <div className="Header">
                <Navbar collapseOnSelect expand="lg" className="bg-black">
                        <Navbar.Brand onClick={() => navigate("/")}>
                            <img alt="Logo" src={logo} id="logo_header"></img>
                            <span className="text-white">Eggspatzen Egweil</span>
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="burger">
                                <img alt="Logo" src={menu}></img>
                        </Navbar.Toggle>
                        <Navbar.Collapse className="justify-content-end" id="burger">
                            <Nav>
                                <Link className={`link ${location.pathname === "/kontakt" ? "active" : ""}`} to="/kontakt">Kontakt</Link>
                                <Link className={`link ${location.pathname === "/geschichte" ? "active" : ""}`} to="/geschichte">Verein</Link>
                                <Link className={`link ${location.pathname === "/vorstandschaft" ? "active" : ""}`} to="/vorstandschaft">Vorstandschaft</Link>
                                <Link className={`link ${location.pathname === "/garde" ? "active" : ""}`} to="/garde">Aktive Garde</Link>
                                <Link className={`link ${location.pathname === "/pps" ? "active" : ""}`} to="/pps">Prinzenpaare</Link>
                                <Link className={`link ${location.pathname === "/galerie" ? "active" : ""}`} to="/galerie">Galerie</Link>
                            </Nav>
                        </Navbar.Collapse>
                </Navbar>

            </div>
        </div >
    );
}

export default Header;